import { useContext, useEffect } from 'react';
import { TrackingContext } from './Tracking.context';
import { AppContext } from '../App.context';
import { TrackerLogger } from './Tracking.events';

const IS_INSTALLED_KEY = 'pwa-installed';

declare global {
	interface Window {
		dataLayer: any;
		gtag: any;
	}
}

export function useTrackingPageView({
	title,
	location,
}: TrackingPageViewProps) {
	const {
		gtag,
		gtm,
		history,
		setHistory,
		locationChannel,
		matomo,
		plausible,
	} = useContext(TrackingContext);
	useEffect(() => {
		if (!title) {
			return;
		}

		if (!location) {
			return;
		}

		let lastPath = undefined;
		if (history.length) {
			lastPath = history[history.length - 1];
			if (lastPath === location) {
				return;
			}
		}

		TrackerLogger.debug(`Page view "${location}"`, {
			title,
			location,
			history,
			lastPath,
		});

		locationChannel.postMessage(location);

		history.push(location);
		setHistory(history);

		if (gtag && window.gtag) {
			// ga.pageview(location, undefined, title);
			window.gtag('event', 'page_view', {
				page_title: title,
				page_location: location,
			});
		}
		if (gtm && window.dataLayer) {
			const gtmEvent = {
				event: 'pageview',
				page: {
					url: location,
					title: title,
				},
			};
			console.log(`I sent the gtm page view event`, gtmEvent);
			window.dataLayer.push(gtmEvent);
		}
		if (matomo) {
			window._paq.push([
				'setCustomUrl',
				location ?? window.location.href,
			]);
			window._paq.push([
				'trackPageView',
				{ documentTitle: title, url: location },
			]);
		}
		if (plausible) {
			const url = window.location.href;
			plausible.trackPageview(
				{
					url,
				},
				{
					callback: () =>
						console.log(`Plausible done sending page view: ${url}`),
				},
			);
		}
	}, [location, title]);
}

export function useTrackingInstallion() {
	const { sendEvent } = useContext(TrackingContext);
	const { isInstalled } = useContext(AppContext);
	useEffect(() => {
		if (localStorage.getItem(IS_INSTALLED_KEY)) {
			return;
		}

		if (!isInstalled) {
			return;
		}

		localStorage.setItem(IS_INSTALLED_KEY, 'true');
		sendEvent({
			type: 'INSTALLED',
		});
	}, [isInstalled]);
}

interface TrackingPageViewProps {
	location?: any;
	title?: string;
}
